/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Missingapikey3Inputs */

const en_locallogin_missingapikey3 = /** @type {(inputs: Locallogin_Missingapikey3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VITE_LOCAL_SESSION_API_KEY is not set. Put the test-env session-service api-key in .env.local (see .env.local.example).`)
};

/**
* | output |
* | --- |
* | "VITE_LOCAL_SESSION_API_KEY is not set. Put the test-env session-service api-key in .env.local (see .env.local.example)." |
*
* @param {Locallogin_Missingapikey3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_missingapikey3 = /** @type {((inputs?: Locallogin_Missingapikey3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Missingapikey3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_missingapikey3(inputs)
});
export { locallogin_missingapikey3 as "localLogin_missingApiKey" }